import React, { Component } from 'react'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import Dashboard from '../Dashboard'
import { Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import arrow_right_img from '../../utils/assets/images/arrow-right.png'
import calendar_img from '../../utils/assets/images/calendar.png'
import SouscriptionSwitcher from '../../components/SouscriptionSwitcher'
import EcheanceDevis  from '../../components/EcheanceDevis'
import * as serializeJavascript from '../../utils/helpers/serializeJavascript'
import BeneficiaireTable  from '../../components/BeneficiaireTable'
import { fetchSouscripteurAction, fetchUpdateSouscripteurAction } from '../../actions/Souscription/Souscripteur'
import { fetchReauthenticateMembersAction } from  '../../actions/Authentification/Reauthenticate'
import { fetchBeneficiairesAction, fetchUpdateBeneficiaireAction } from '../../actions/Souscription/Beneficiaire'

import {
  fetchReauthenticateCourtiersAction
} from  '../../actions/Authentification/ReauthenticateCourtiers'

class Devis extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isCurrentLoginCourtier: localStorage.getItem("isCurrentLoginCourtier"),
      submitAllBeneficiairesSuccess: false,
      submitAllSuccess: true,
      applyRedirectPrev: false,
      applyRedirectNext: false,
      applyRedirectFromDevis: false,
      submitBeneficiaireCount: 0,
      allBeneficiaires: [],
      isAllBeneficiaires: false,
      thisNewStartDate: props.getSouscripteur.souscripteurData.startDate,
      forms: {},
    }
  }
  componentDidMount() {
    document.title = `Dashboard Membre | Devis`

    const { isCurrentLoginCourtier } = this.state
    const { getReauthenticate, getReauthenticateCourtiers, reauthenticateMembers, reauthenticateCourtiers, userGetBeneficiaires, userGetSouscripteur } = this.props
    
    if (isCurrentLoginCourtier) {
      if (Object.keys(reauthenticateCourtiers.courtierData).length === 0) {
        getReauthenticateCourtiers()
      }

      if (reauthenticateCourtiers.courtierData.souscripteurID) {
        userGetSouscripteur(reauthenticateCourtiers.courtierData.souscripteurID)
        userGetBeneficiaires(reauthenticateCourtiers.courtierData.souscripteurID)
      }else {
        getReauthenticateCourtiers()
      }
    }else {
      if (Object.keys(reauthenticateMembers.userData).length === 0 || !reauthenticateMembers.userData.souscripteurID) {
        getReauthenticate()
      }
      if (reauthenticateMembers.userData.souscripteurID) {
        userGetSouscripteur(reauthenticateMembers.userData.souscripteurID)
        userGetBeneficiaires(reauthenticateMembers.userData.souscripteurID)
      }
    }
  }

  componentWillUpdate(nextProps, nextState) {
    const { reauthenticateMembers, reauthenticateCourtiers, userGetBeneficiaires, userGetSouscripteur, getBeneficiaires, updateBeneficiaire, updateSouscripteur } = nextProps
    const { allBeneficiaires, submitBeneficiaireCount } = nextState

    if (reauthenticateMembers.userData.length !== this.props.reauthenticateMembers.userData.length) {
      if (reauthenticateMembers.userData.souscripteurID) {
        userGetSouscripteur(reauthenticateMembers.userData.souscripteurID)
        userGetBeneficiaires(reauthenticateMembers.userData.souscripteurID)
      }
    }
    if (reauthenticateCourtiers.courtierData.length !== this.props.reauthenticateCourtiers.courtierData.length) {
      if (reauthenticateCourtiers.courtierData.souscripteurID) {
        userGetSouscripteur(reauthenticateCourtiers.courtierData.souscripteurID)
        userGetBeneficiaires(reauthenticateCourtiers.courtierData.souscripteurID)
      }
    }
    if (getBeneficiaires.beneficiairesData.length !== this.props.getBeneficiaires.beneficiairesData.length) {
      if (getBeneficiaires.beneficiairesData.data && getBeneficiaires.beneficiairesData.data !== undefined) {
        this.setState({ allBeneficiaires: [ ...getBeneficiaires.beneficiairesData.data ] })
      }
    }
    if (updateBeneficiaire.isSuccess && updateSouscripteur.isSuccess && nextState.submitAllSuccess) {
      if (submitBeneficiaireCount === 0 || submitBeneficiaireCount !== this.state.submitBeneficiaireCount) {
        let thisTotalBeneficiaires = allBeneficiaires.length

        if (thisTotalBeneficiaires > submitBeneficiaireCount) {
          this.setState({ submitBeneficiaireCount: submitBeneficiaireCount + 1 })
        }
        if (thisTotalBeneficiaires === submitBeneficiaireCount) {
          this.setState({ submitAllBeneficiairesSuccess: true, submitAllSuccess: false })
        }
      }
    }
  }

  handleBeneficiairePrev = event => {
    event.preventDefault()
    const { allBeneficiaires, thisNewStartDate, isCurrentLoginCourtier } = this.state
    const { userUpdateBeneficiaire, userUpdateSouscripteur, reauthenticateMembers, reauthenticateCourtiers } = this.props

    if (allBeneficiaires.length !== null) {
      for (var i = 0; i < allBeneficiaires.length; i++) {
        if (allBeneficiaires[i]._id) {
          userUpdateBeneficiaire(allBeneficiaires[i]._id, serializeJavascript.sanitize(allBeneficiaires[i]))
        }
      }

      if(isCurrentLoginCourtier) {
        userUpdateSouscripteur(reauthenticateCourtiers.courtierData.souscripteurID, serializeJavascript.sanitize({startDate: thisNewStartDate}))
      }else {
        userUpdateSouscripteur(reauthenticateMembers.userData.souscripteurID, serializeJavascript.sanitize({startDate: thisNewStartDate}))
      }
      this.setState({ applyRedirectPrev: true })
    }
  }

  handleBeneficiaireNext = event => {
    event.preventDefault()
    const { allBeneficiaires, thisNewStartDate, isCurrentLoginCourtier } = this.state
    const { userUpdateBeneficiaire, userUpdateSouscripteur, reauthenticateMembers, reauthenticateCourtiers } = this.props
    if (allBeneficiaires.length !== null) {
      for (var i = 0; i < allBeneficiaires.length; i++) {
        if (allBeneficiaires[i]._id) {
          userUpdateBeneficiaire(allBeneficiaires[i]._id, serializeJavascript.sanitize(allBeneficiaires[i]))
        }
      }

      if(isCurrentLoginCourtier) {
        userUpdateSouscripteur(reauthenticateCourtiers.courtierData.souscripteurID, serializeJavascript.sanitize({startDate: thisNewStartDate}))
      }else {
        userUpdateSouscripteur(reauthenticateMembers.userData.souscripteurID, serializeJavascript.sanitize({startDate: thisNewStartDate}))
      }
      this.setState({ applyRedirectNext: true })
    }
  }

  handleChangeBeneficiaire = (currNewAllBeneficiaires) => {
    this.setState({ allBeneficiaires: [ ...currNewAllBeneficiaires ] })
  }
  handleChangeStartDate = (getStartDate) => {
    this.setState({ thisNewStartDate: getStartDate })
  }
  checkFormValid = (name, isValid) => {
    this.setState((prev) => {
      prev.forms[name] = isValid
      return {forms: prev.forms}
    })
  }
  handleAddBeneficiaire = (event) => {
    event.preventDefault()
    const { allBeneficiaires, thisNewStartDate, isCurrentLoginCourtier } = this.state
    const { userUpdateBeneficiaire, userUpdateSouscripteur, reauthenticateMembers, reauthenticateCourtiers } = this.props

    if (allBeneficiaires.length !== null) {
      for (var i = 0; i < allBeneficiaires.length; i++) {
        if (allBeneficiaires[i]._id) {
          userUpdateBeneficiaire(allBeneficiaires[i]._id, allBeneficiaires[i])
        }
      }
      if(isCurrentLoginCourtier) {
        userUpdateSouscripteur(reauthenticateCourtiers.courtierData.souscripteurID, {startDate: thisNewStartDate})
      }else {
        userUpdateSouscripteur(reauthenticateMembers.userData.souscripteurID, {startDate: thisNewStartDate})
      }
      this.setState({ applyRedirectFromDevis: true })
    }
  }
  render() {
    const { match, reauthenticateMembers, reauthenticateCourtiers, getBeneficiaires, updateBeneficiaire, getSouscripteur } = this.props
    const { allBeneficiaires, submitAllBeneficiairesSuccess, applyRedirectPrev, applyRedirectNext, applyRedirectFromDevis, forms, isCurrentLoginCourtier } = this.state
    let invaildForm = Object.values(forms).length && !Object.values(forms).reduce((a, b) => a && b)
    return(
      <div>
        <Header userIsSuccessLogin={isCurrentLoginCourtier ? reauthenticateCourtiers.isSuccess : reauthenticateMembers.isSuccess} />
        {(getSouscripteur.souscripteurData.status === "submitted" || getSouscripteur.souscripteurData.status === "payment-pending") && <Redirect to="/soumis" push/>}
        {getSouscripteur.souscripteurData.status === "police-active" && <Redirect to="/validation-souscription" push/>}
        {(reauthenticateMembers.isLoading || reauthenticateCourtiers.isLoading)
          ?
            <div className="aps-spinner-container-loading">
              <div className="uk-spinner">
                <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 30 30" ratio="1">
                   <circle fill="none" stroke="#AEC340" cx="15" cy="15" r="14"></circle>
                </svg>
              </div>
              <div className="aps-section-register-desc">chargement en cours</div>
            </div>
          :
            <Dashboard match={match}>
              <div className="aps-dashboard-menu-tab-content">
                <SouscriptionSwitcher match={match} />


                {(allBeneficiaires.length === 0 || updateBeneficiaire.isLoading || getBeneficiaires.isLoading || getSouscripteur.isLoading)
                  ?
                    <div className="aps-spinner-component-loading">
                      <div className="uk-spinner">
                        <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 30 30" ratio="1">
                           <circle fill="none" stroke="#AEC340" cx="15" cy="15" r="8"></circle>
                        </svg>
                      </div>
                      <div className="aps-section-register-desc">chargement en cours</div>
                    </div>
                  :
                    <div>
                      {(submitAllBeneficiairesSuccess && applyRedirectNext) &&
                        <div>
                          <Redirect to="/questionnaire" push/>
                        </div>
                      }
                      {(submitAllBeneficiairesSuccess && applyRedirectPrev) &&
                        <div>
                          <Redirect to="/beneficiaire" push/>
                        </div>
                      }
                      {(submitAllBeneficiairesSuccess && applyRedirectFromDevis) &&
                        <div>
                          <Redirect to={{
                              pathname: '/beneficiaire',
                              state: { fromDevis: true }
                            }} push/>
                        </div>
                      }
                      <div className="uk-text-center aps-dashboard-devis-title uk-text-bold">
                        {getSouscripteur.souscripteurData.lastname}, voici votre devis
                      </div>
                      <div className="aps-dashboard-devis-container">
                        <div className="aps-dashboard-devis-desc uk-text-bold">
                          A partir de quelle date souhaitez-vous bénéficier de vos garanties ?
                        </div>
                        {/*Rrecuperer le change ici*/}
                        {getSouscripteur.isSuccess &&
                          (
                            <EcheanceDevis
                              checkFormValid={this.checkFormValid}
                              getStartDate={getSouscripteur.souscripteurData.startDate}
                              checkChangeStartDate={this.handleChangeStartDate}
                            />
                          )
                        }

                        <div className="aps-dashboard-devis-desc uk-text-bold " style={{paddingBottom: "20px"}}>
                          Veuillez noter que ce devis n&apos;entraîne aucune obligation et sera
                          soumis à une souscription médicale.
                        </div>

                        <div className="aps-dashboard-devis-tile uk-tile uk-tile-muted uk-text-center">
                          <p>
                            Ce devis est calculé en F CFA en fonction des informations
                            suivantes :{" "}
                          </p>
                        </div>

                        <BeneficiaireTable
                          checkChangeBeneficiaire={this.handleChangeBeneficiaire}
                          beneficiaires={allBeneficiaires}
                          checkFormValid={this.checkFormValid}
                          souscripteurID={isCurrentLoginCourtier ? reauthenticateCourtiers.courtierData.souscripteurID : reauthenticateMembers.userData.souscripteurID}
                        />

                          <div className="uk-text-center aps-dashboard-beneficiare-action-btn">
                            <button
                              onClick={event => this.handleAddBeneficiaire(event)}
                              className="uk-button aps-btn-add-beneficiaire aps-btn-add-beneficiaire-this-dashboard"
                            >
                              <span
                                className="aps-icon-add-beneficiaire"
                                data-uk-icon="icon: plus-circle"
                              />
                              Ajouter un bénéficiaire
                            </button>
                          </div>

                        <div>
                          <div className="aps-section-alerte-green-container-simulation-check" data-uk-grid>
                            <div className="uk-width-1-6 aps-section-alerte-green-arrow-right">
                              <img src={arrow_right_img} alt="arrow-right" />
                            </div>
                            <div className="uk-width-expand aps-section-alerte-green-expand">
                              <p className="aps-section-alerte-green-content-full uk-text-bold uk-text-justify">
                                Couverture des soins dans le réseau des prestataires santé «
                                tiers payant » de Atlantique Assurances Bénin, dans les limites
                                prévues pour la (les) formule(s) choisie(s) ci-dessus.
                              </p>
                            </div>
                          </div>
                          <div className="aps-section-alerte-green-container-simulation-check" data-uk-grid>
                            <div className="uk-width-1-6 aps-section-alerte-green-arrow-right">
                              <img src={arrow_right_img} alt="arrow-right" />
                            </div>
                            <div className="uk-width-expand aps-section-alerte-green-expand">
                              <p className="aps-section-alerte-green-content-full uk-text-bold uk-text-justify">
                                Les tarifs ci-dessus sont en F CFA et en vigueur à partir du 1er avril 2019. Ils peuvent subir des majorations en fonctions
                                des pathologies déclarées sur le questionnaire médical. La
                                prime définitive sera confirmée au souscripteur après analyse
                                du questionnaire médical par l’assureur. Le paiement intégral
                                de la prime active ensuite les garanties (art. 13 du code
                                CIMA).
                              </p>
                            </div>
                          </div>

                          <div className="aps-section-alerte-green-container-simulation-none" data-uk-grid >
                            <div className="uk-width-1-6 aps-section-alerte-green-arrow-right">
                              <img src={calendar_img} alt="calendar" />
                            </div>
                            <div className="uk-width-expand aps-section-alerte-green-expand">
                              <p className="aps-section-alerte-green-content-full uk-text-bold">
                                Délais d'attente :
                              </p>
                            </div>
                          </div>
                          <div className="aps-section-alerte-green-container-simulation-none" data-uk-grid>
                            <div className="data-uk-width-1-6 aps-section-alerte-green-arrow-right" />
                            <div className="uk-width-expand aps-section-alerte-green-expand">
                              <ul className="uk-list uk-list-bullet aps-section-alerte-green-content-bullet">
                                <li>Pas de délai de carence en cas d’accident ;
                                </li>
                                <li>01 mois après la souscription pour les soins ordinaires ;
                                </li>
                                <li>06 mois pour la lunetterie et les prothèses dentaires ;
                                </li>
                                <li>06 mois pour les maladies chroniques non rachetées, non déclarées et survenant pour la première fois pendant le contrat ;
                                </li>
                                <li>09 mois pour la maternité.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="aps-dashboard-souscription-switch">
                        <div className="aps-dashboard-souscription-switch-btn aps-bottom-btn-text-position-second">
                          <button
                            className={`uk-button aps-btn-silver aps-btn-silver-dashboard-btn  ${!this.state.forms ? 'aps-section-register-action-btn-no-active apply-disabled-btn' : ''}`}
                            onClick={(event) => this.handleBeneficiairePrev(event)}
                            disabled={!this.state.forms}
                          >Section précédente</button>

                          <button
                            className={`uk-button aps-btn-green aps-btn-green-dashboard-btn  ${invaildForm ? 'aps-section-register-action-btn-no-active apply-disabled-btn' : ''}`}
                            onClick={(event) => this.handleBeneficiaireNext(event)}
                            disabled={invaildForm}
                          >Section suivante</button>
                        </div>
                      </div>
                    </div>
                }
              </div>
              {(reauthenticateMembers.isError && !isCurrentLoginCourtier) &&
                <div>
                  <Redirect to='/connexion' push/>
                </div>
              }
              {(reauthenticateCourtiers.isError && !isCurrentLoginCourtier) &&
                <div>
                  <Redirect to='/connexion-intermediaires' push/>
                </div>
              }
            </Dashboard>
          }
        <Footer />
      </div>
    )
  }
}

const mapStateToProps = ({ reauthenticateMembers, reauthenticateCourtiers, getBeneficiaires, getSouscripteur, updateSouscripteur, updateBeneficiaire }) => {
  return {
    reauthenticateMembers,
    reauthenticateCourtiers,
    getBeneficiaires,
    getSouscripteur,
    updateSouscripteur,
    updateBeneficiaire,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    getReauthenticate: () => dispatch(fetchReauthenticateMembersAction()),
    getReauthenticateCourtiers: () => dispatch(fetchReauthenticateCourtiersAction()),
    userGetSouscripteur: (souscripteurID) => dispatch(fetchSouscripteurAction(souscripteurID)),
    userUpdateSouscripteur: (souscripteurID, souscripteurData) => dispatch(fetchUpdateSouscripteurAction(souscripteurID, souscripteurData)),
    userGetBeneficiaires: (souscripteurID) => dispatch(fetchBeneficiairesAction(souscripteurID)),
    userUpdateBeneficiaire: (beneficiaireID, beneficiaireData) => dispatch(fetchUpdateBeneficiaireAction(beneficiaireID, beneficiaireData)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Devis)



// WEBPACK FOOTER //
// ./src/containers/Devis/index.js